import Modal from '/web/shared/Modal'
import FileInput, { FileInputResult, getFileAsString } from '/web/shared/FileInput'
import { importTemplate } from './util'
import { toastStore, i18nStore } from '/web/store'
import { sagaStore } from './state'

export const ImportTemplate = () => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const onChange = async (files: FileInputResult[]) => {
    if (!files.length) {
      return
    }

    try {
      const content = await getFileAsString(files[0])
      const parsed = JSON.parse(content)
      importTemplate(parsed)
      toastStore.success(i18n.t.saga_import_success)
      sagaStore.setState({ showModal: 'none' })
    } catch (ex: any) {
      toastStore.error(ex.message)
      return
    }
  }

  return (
    <Modal show close={() => sagaStore.setState({ showModal: 'none' })} title={i18n.t.saga_import_title}>
      <FileInput fieldName="file" label={i18n.t.saga_import_json_label} onUpdate={onChange} />
    </Modal>
  )
}
